import React from 'react';
import { Routes, Route, NavLink, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminArticles from './admin/AdminArticles';
import AdminArticleEdit from './admin/AdminArticleEdit';
import AdminQcm from './admin/AdminQcm';
import AdminQcmSubject from './admin/AdminQcmSubject';
import AdminQcmImport from './admin/AdminQcmImport';
import AdminQcmEdit from './admin/AdminQcmEdit';
import AdminPage from './admin/AdminPage';
import AdminNotes from './admin/AdminNotes';
import AdminPlans from './admin/AdminPlans';
import AdminNoteEdit from './admin/AdminNoteEdit';
import AdminNotesSubject from './admin/AdminNotesSubject';
import AdminCards from './admin/AdminCards';
import AdminCardsEdit from './admin/AdminCardsEdit';
import AdminHome from './admin/AdminHome';
import AdminCv from './admin/AdminCv';
import ThemeToggle from '../components/ThemeToggle';

export default function Admin() {
  const { username, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-top"><h2>admin.</h2><ThemeToggle /></div>
        <NavLink to="/admin" end>Tableau de bord</NavLink>
        <NavLink to="/admin/articles">Articles</NavLink>
        <NavLink to="/admin/notes">Notes</NavLink>
        <NavLink to="/admin/plans">Plans</NavLink>
        <NavLink to="/admin/cards">Cards</NavLink>
        <NavLink to="/admin/qcm">QCM</NavLink>
        <NavLink to="/admin/about">Page À propos</NavLink>
        <NavLink to="/admin/cv">CV</NavLink>
        <div style={{ marginTop: 'auto', padding: '1rem 0', fontSize: '.85rem', opacity: 0.7 }}>
          <div>connectée : <strong>{username}</strong></div>
          <Link to="/" style={{ color: 'var(--sun)', display: 'inline-block', margin: '.5rem 0' }}>← voir le site</Link>
        </div>
        <button className="logout" onClick={doLogout}>se déconnecter</button>
      </aside>
      <main className="admin-main">
        <Routes>
          <Route index element={<AdminHome />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="articles/new" element={<AdminArticleEdit />} />
          <Route path="articles/:id" element={<AdminArticleEdit />} />
          <Route path="plans" element={<AdminPlans />} />
          <Route path="notes" element={<AdminNotes />} />
          <Route path="notes/sujet/:id" element={<AdminNotesSubject key="subject" />} />
          <Route path="notes/new" element={<AdminNoteEdit key="new" />} />
          <Route path="notes/:id" element={<AdminNoteEdit key="edit" />} />
          <Route path="cards" element={<AdminCards />} />
          <Route path="cards/nouveau" element={<AdminCardsEdit key="new" />} />
          <Route path="cards/:id" element={<AdminCardsEdit key="edit" />} />
          <Route path="qcm" element={<AdminQcm />} />
          <Route path="qcm/sujets/:id" element={<AdminQcmSubject />} />
          <Route path="qcm/sujets/:id/import" element={<AdminQcmImport />} />
          <Route path="qcm/nouveau" element={<AdminQcmEdit />} />
          <Route path="qcm/:id" element={<AdminQcmEdit key="edit" />} />
          <Route path="about" element={<AdminPage slug="about" />} />
          <Route path="cv" element={<AdminCv />} />
        </Routes>
      </main>
    </div>
  );
}
